export const FETCH_STORE_SCHEDULE_OVERRIDE_FAILURE = "FETCH_STORE_SCHEDULE_OVERRIDE_FAILURE";
export const FETCH_STORE_SCHEDULE_OVERRIDE_REQUEST = "FETCH_STORE_SCHEDULE_OVERRIDE_REQUEST";
export const FETCH_STORE_SCHEDULE_OVERRIDE_SUCCESS = "FETCH_STORE_SCHEDULE_OVERRIDE_SUCCESS";
